export enum ReportTypeCode {
    asis = 1,
    kpi,
    custom
}
